import React from "react";

import SettingsPlatformsPage from "@/pages/settings/platforms";

const PlatformsPageComponent: React.FC = () => {
  return <SettingsPlatformsPage />;
};

export default PlatformsPageComponent;
